import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import { landingRoutes } from 'app/util/landingPage/landingPageConstants';

@inject('$auth', '$devices', '$syn')
@observer
export default class DefaultView extends Component {
  render() {
    const { $auth, $devices, $syn } = this.props;

    // New users get pageType: observationDeck, Old users may not have anything set
    // We default them to networkExplorer and let them opt-in to observationDeck
    const {
      defaultLandingPageType = 'observationDeck',
      defaultLandingPageValue,
      rolesetLandingPageType,
      rolesetLandingPageValue
    } = $auth.activeUser;
    const lastVistedPage = localStorage.getItem('kentik.lastVisitedPage');
    const ssoInitialReferer = sessionStorage.getItem('kentik.ssoInitialReferer');

    // TODO: We'll plan to remove these when synthetics is sufficiently supported within Observation Deck
    const legacyDefaultPath =
      $devices.deviceSummaries.length === 0 && $syn.tests?.size > 0 ? '/v4/synthetics' : '/v4/core';

    const redirects = {
      ...landingRoutes,
      networkExplorer: () => legacyDefaultPath,
      savedView: (value) => `/v4/library/saved-views/${value}`
    };

    if (
      $auth.openConfig.ssoNext &&
      ($auth.openConfig.initialReferer.startsWith('https://portal.kentik.com') ||
        $auth.openConfig.initialReferer.startsWith('https://portal.our1.kentik.com') ||
        $auth.openConfig.initialReferer.startsWith('https://portal.kentik.eu'))
    ) {
      const isOur1 = $auth.openConfig.initialReferer.startsWith('https://portal.our1.kentik.com');
      if (isOur1) {
        window.location.href = 'https://next.our1.kentik.com';
      } else {
        window.location.href = $auth.currentRegion === 'US' ? 'https://next.kentik.com' : 'https://next.kentik.eu';
      }

      return null;
    }
    if (ssoInitialReferer) {
      sessionStorage.removeItem('kentik.ssoInitialReferer');
      return <Redirect to={new URL(ssoInitialReferer).pathname} />;
    }

    if (lastVistedPage) {
      localStorage.removeItem('kentik.lastVisitedPage');
      return <Redirect to={lastVistedPage} />;
    }

    if (rolesetLandingPageType && redirects[rolesetLandingPageType]) {
      return <Redirect to={redirects[rolesetLandingPageType](rolesetLandingPageValue)} />;
    }

    if (defaultLandingPageType && redirects[defaultLandingPageType]) {
      return <Redirect to={redirects[defaultLandingPageType](defaultLandingPageValue)} />;
    }

    return <Redirect to="/v4/home" />;
  }
}
